import React from "react";
import { toCamelCaseForFirstChar } from "../../services/utilApis";

const WebsiteBreadCrumb = ({ title, subtitle }) => {
  return (
    <div className="web-breadcremb">
      <img src="/heyinterns-breadcrumb.jpg" alt="" className="img-fluid" />
      <div className="breadcrumb-content">
        {title && <h2 className="breadcrumb-text">{toCamelCaseForFirstChar(title)}</h2>}
        {subtitle && subtitle.length > 0 && (
          <h6 className="breadcrumb-subheading">{toCamelCaseForFirstChar(subtitle)}</h6>
        )}
      </div>
    </div>
  );
};

export default WebsiteBreadCrumb;
